import { API, Logger } from 'aws-amplify';
import Vue from 'vue';
import store from '@/store';
import { isIosDevice } from '@/utils/platform';

const logger = new Logger('ProjectsService');

const ApiName = 'esite';
const PathRoot = process.env.VUE_APP_PROJECTS_API_PATH;

const Projects = {
  get(id) {
    return new Promise((resolve, reject) => {
      const path = `${PathRoot}/${id}`;

      const { unsupported } = store.state;
      const unsupportedQuery = unsupported ? unsupported.toString() : '';

      // Add authorization header
      const { sitePassword } = store.state;
      const init = {
        ...sitePassword && { headers: { Authorization: sitePassword } },
        ...unsupportedQuery && { queryStringParameters: { sq: unsupportedQuery } },
      };
      // Get project from API
      API.get(ApiName, path, init)
        .then((response) => {
          store.commit('project', response);
        })
        .then(this.getCookies)
        // Get hotspots for project
        .then(this.getHotspots)
        .then(() => {
          store.commit('projectLoaded', true);
          resolve();
        })
        .catch((error) => {
          const msg = error.response ? error.response.data : error;
          reject(msg);
        });
    });
  },
  getHotspots() {
    const { project } = store.state;
    const url = project.hotspotUrl || project.hotspotsUrl;
    return new Promise((resolve, reject) => {
      if (url) {
        // Fetch json file
        const init = process.env.VUE_APP_LOCALHOST === 'true' ? { mode: 'cors', withCredentials: 'true' } : { mode: 'no-cors' };
        fetch(url, init)
          .then(response => response.json())
          .then((json) => {
            // Store hotspots
            store.commit('hotspots', json.hotspots);
            resolve();
          })
          .catch((err) => {
            logger.error(err);
            reject(err);
          });
      } else {
        // Store empty hotspots
        store.commit('hotspots', []);
        resolve();
      }
    });
  },
  getCookies() {
    if (isIosDevice() || process.env.VUE_APP_LOCALHOST === 'true') {
      store.commit('signedSecurity', true);
      return Promise.resolve();
    }
    const { project } = store.state;
    const url = project.cookieUrl;
    return new Promise((resolve, reject) => {
      if (url) {
        // Fetch json file
        const mode = process.env.VUE_APP_LOCALHOST === 'true' ? 'cors' : 'no-cors';
        fetch(url, { mode })
          .then((/* response */) => {
            store.commit('signedSecurity', true);
            resolve();
          })
          .catch((err) => {
            logger.error(err);
            reject(err);
          });
      } else {
        store.commit('signedSecurity', true);
        resolve();
      }
    });
  },
};


Vue.prototype.$projects = Projects;

export { Projects as default };
